import React from "react";
import styles from "./Packaging.module.css";
import ProductDetailsComponent from "../../../../../components/ProductDetailsComponent/ProductDetailsComponent";
import CheckListComponent from "../../../../../components/CheckListComponent/CheckListComponent";
const Packaging = () => {
  const Options = [
    { title: "Mixer sanitized prior to use  " },
    { title: "Ingredient scale calibrated" },
    { title: "Water measurement double-checked" },
    { title: "Verify ingredient temperature before mixing (if applicable)" },
    { title: "Record lot numbers for traceability (if required)" },
    { title: "No food or drink in the areas" },
  ];

  const Options2 = [
    { title: "Dough rested according to recipe before shaping" },
    { title: "Cross-contact between allergen and non-allergen items avoided" },
    { title: "Final product portioning verified (by weight or count)" },
    { title: "Confirm mixing bowl and attachments are sanitized" },
    { title: "Contaminated product discarded when identified" },
  ];
  return (
    <div className={styles.MainCont}>
      <div className={styles.RightCont}>
        <CheckListComponent Options={Options} Heading={"GMP"} />
      </div>
    </div>
  );
};

export default Packaging;
